import script from "./editorBox.vue?vue&type=script&setup=true&lang=js"
export * from "./editorBox.vue?vue&type=script&setup=true&lang=js"

import "./editorBox.vue?vue&type=style&index=0&id=0673a06f&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0673a06f"]])

export default __exports__